import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import * as Sentry from "@sentry/react";

import {ConfigProvider, theme} from 'antd';
import {StyleProvider} from '@ant-design/cssinjs';

import './Main.css';
import './Responsiveness.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
// import 'animate.css';
import 'react-circular-progressbar/dist/styles.css';


import Main from './Main';
import SpinningLoader from "@/utils/SpinningLoader";
import {Button} from "reactstrap";


Sentry.init({
    dsn: process.env.MIX_SENTRY_REACT_DSN,
    environment: process.env.MIX_SENTRY_REACT_ENVIRONMENT,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    tracesSampleRate: process.env.MIX_SENTRY_REACT_TRACES_SAMPLE_RATE,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

const UI = () => {
    return (
        <Sentry.ErrorBoundary fallback={({error, componentStack, resetError}) => (
            <React.Fragment>
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        textAlign: 'center',
                        display: 'grid',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                    <div>
                        <ga-error-popup
                            heading="<h1 style='color: grey;'>Oops! Something Went Wrong</h1>"
                            subHeading={`<p>Please try a hard refresh or clear your cache. If the problem persists, contact support for assistance at <br /> <a href='mailto:contact@crystalball.pro'>contact@crystalball.pro</a>.</p>`}
                            bannerImg="/images/error-popup-image.svg">
                        </ga-error-popup>
                        <Button style={{borderRadius: 25}} outline color="primary"
                                onClick={() => {
                                    resetError();
                                }}
                        >
                            Go Back
                        </Button>

                        <div className={"hidden"}>
                            {JSON.stringify(error, null, 2)}
                        </div>
                        <div className={"hidden"}>
                            {JSON.stringify(componentStack, null, 2)}
                        </div>

                    </div>
                </div>
                {/*<div>{componentStack}</div>*/}
            </React.Fragment>
        )}>
            <Suspense fallback={
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}>
                    <SpinningLoader/>
                </div>
            }>
                <ConfigProvider
                    theme={{
                        components: {
                            Select: {
                                colorBorder: '#bdbdbd',
                                colorTextPlaceholder: '#666666'
                            },
                            DatePicker: {
                                colorBorder: '#bdbdbd',
                                colorTextPlaceholder: '#666666'
                            },
                        },
                    }}
                >
                    <StyleProvider layer>
                        <BrowserRouter>
                            <React.StrictMode>
                                <Switch>
                                    <Route component={Main}/>
                                </Switch>
                            </React.StrictMode>
                        </BrowserRouter>
                    </StyleProvider>
                </ConfigProvider>
            </Suspense>
        </Sentry.ErrorBoundary>
    );
}

export default UI;


if (document.getElementById('ui')) {
    ReactDOM.render(<UI/>, document.getElementById('ui'));
}
